import { FC } from "react";

const MouseClickRight: FC<{ size?: number | string }> = ({ size = 18 }) => {
  return (
    <svg
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      imageRendering="optimizeQuality"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      viewBox="0 0 350 512.41"
    >
      <g fillRule="nonzero">
        <path
          fill="#FFFFFF"
          d="M17.79 242.76h121.9v-33.87c-9.96-3.66-17.16-13.27-17.16-24.48v-37.72c0-11.21 7.18-20.83 17.16-24.49V72.94h-8.79c-31.1 0-59.38 12.73-79.88 33.23-20.5 20.5-33.23 48.78-33.23 79.88v56.71zm139.7-120.55c9.99 3.67 17.16 13.31 17.16 24.48v37.72c0 11.16-7.2 20.8-17.16 24.47v33.88h121.14l.75.04v-56.75c0-31.1-12.73-59.38-33.23-79.88-20.5-20.5-48.78-33.23-79.87-33.23h-8.79v49.27zM271.8 57.13l36.07-36.08c4.74-4.73 12.42-4.73 17.15 0 4.74 4.74 4.73 12.42 0 17.16l-35.7 35.69a107.783 107.783 0 00-17.52-16.77zm-52.84-21.19L233.04 6.3c3.2-5.86 10.55-8.02 16.4-4.82 5.87 3.2 8.03 10.54 4.83 16.41l-12.18 23.28-23.13-5.23zm93.85 89.43a106.14 106.14 0 00-6.4-22.97l25.7-13.86c5.86-3.21 13.21-1.04 16.41 4.82 3.2 5.86 1.04 13.21-4.82 16.4l-30.89 15.61zm-33.43 135.15l-.75.04H17.79v120.95c0 31.1 12.73 59.38 33.23 79.88 20.5 20.5 48.78 33.23 79.88 33.23h35.38c31.09 0 59.37-12.73 79.87-33.23 20.5-20.5 33.23-48.78 33.23-79.88V260.52zm-113.1 251.89H130.9c-36 0-68.74-14.72-92.46-38.44S0 417.51 0 381.51V186.05c0-36.01 14.72-68.74 38.44-92.46S94.9 55.15 130.9 55.15h35.38c36.01 0 68.74 14.73 92.45 38.44 23.72 23.72 38.45 56.45 38.45 92.46v195.46c0 36-14.73 68.74-38.45 92.46-23.71 23.71-56.44 38.44-92.45 38.44z"
        ></path>
        <path
          fill="#FFF185"
          d="M157.49 72.94v49.27c9.99 3.67 17.16 13.31 17.16 24.48v37.72c0 11.16-7.2 20.8-17.16 24.47v33.88h121.14l.75.04v-56.75c0-31.1-12.73-59.38-33.23-79.88-20.5-20.5-48.78-33.23-79.87-33.23h-8.79z"
        ></path>
      </g>
    </svg>
  );
};

export default MouseClickRight;
